import React, { useEffect } from 'react';
import { bool, func, shape } from 'prop-types';
import { useForm } from 'react-hook-form';
import { AUIModal } from '@ancert/aui-modal';
import AUIInputTextField from '@ancert/aui-input-text-field';
import AUIInputTextAreaField from '@ancert/aui-input-textarea-field';
import Field from '../Field';
import { defaultValues, resolver } from './form';
import { MAX_TEXT_AREA } from '../../config';

const ModalPersonasImplicadas = ({ editData, show, onClose, onAccept, isVerData }) => {
  const { control, formState, handleSubmit, reset } = useForm({
    defaultValues,
    resolver,
    mode: 'onSubmit',
  });

  useEffect(() => {
    if (editData) {
      reset(editData);
    }
  }, [editData]);

  const onSubmit = (data) => {
    onAccept(data);
    reset(defaultValues);
  };

  const closeModal = () => {
    reset(defaultValues);
    onClose();
  };

  const buttons = [
    {
      id: 'primary',
      mode: 'primary',
      label: 'Aceptar',
      onClick: handleSubmit(onSubmit),
    },
    {
      id: 'tertiary',
      mode: 'tertiary',
      label: 'Cancelar',
      onClick: closeModal,
      disabled: false,
    },
  ];

  return (
    <AUIModal
      size="lg"
      title="Personas implicadas en el hecho"
      show={show}
      actionButtons={buttons}
      autoHeight
      onClose={closeModal}
    >
      <form autoComplete="off">
        <div className="o-grid">
          <div className="o-grid__row">
            <div className="o-grid__col-4">
              {!isVerData ? (
                <AUIInputTextField
                  required
                  label="Nombre"
                  id="nombre"
                  name="nombre"
                  controlRef={control}
                  errors={formState.errors}
                />
              ) : (
                <Field label="Nombre">{editData.nombre}</Field>
              )}
            </div>
            <div className="o-grid__col-4">
              {!isVerData ? (
                <AUIInputTextField
                  required
                  label="Primer apellido"
                  id="apellido1"
                  name="apellido1"
                  controlRef={control}
                  errors={formState.errors}
                />
              ) : (
                <Field label="Primer apellido">{editData.apellido1}</Field>
              )}
            </div>
            <div className="o-grid__col-4">
              {!isVerData ? (
                <AUIInputTextField
                  label="Segundo apellido"
                  id="apellido2"
                  name="apellido2"
                  controlRef={control}
                  errors={formState.errors}
                />
              ) : (
                <Field label="Segundo apellido">{editData.apellido2}</Field>
              )}
            </div>
          </div>
          <div className="o-grid__row">
            <div className="o-grid__col-6">
              {!isVerData ? (
                <AUIInputTextField
                  label="Cargo"
                  id="cargo"
                  name="cargo"
                  controlRef={control}
                  errors={formState.errors}
                />
              ) : (
                <Field label="Cargo">{editData.cargo}</Field>
              )}
            </div>
            <div className="o-grid__col-6">
              {!isVerData ? (
                <AUIInputTextField
                  label="Email"
                  id="email"
                  name="email"
                  controlRef={control}
                  errors={formState.errors}
                />
              ) : (
                <Field label="Email">{editData.email}</Field>
              )}
            </div>
          </div>
          <div className="o-grid__row">
            <div className="o-grid__col-4">
              {!isVerData ? (
                <AUIInputTextField
                  label="Teléfono"
                  id="telefono"
                  name="telefono"
                  controlRef={control}
                  errors={formState.errors}
                  keyfilter="pint"
                />
              ) : (
                <Field label="Teléfono">{editData.telefono}</Field>
              )}
            </div>
            <div className="o-grid__col-8">
              {!isVerData ? (
                <AUIInputTextField
                  label="Dirección"
                  id="direccion"
                  name="direccion"
                  controlRef={control}
                  errors={formState.errors}
                />
              ) : (
                <Field label="Dirección">{editData.direccion}</Field>
              )}
            </div>
          </div>
          <div className="o-grid__row">
            <div className="o-grid__col-12">
              {!isVerData ? (
                <AUIInputTextAreaField
                  required
                  id="hechos"
                  name="hechos"
                  label="Hechos acontecidos (máx. 150 caracteres)"
                  controlRef={control}
                  maxLength={MAX_TEXT_AREA}
                  errors={formState.errors}
                />
              ) : (
                <Field label="Hechos acontecidos (máx. 150 caracteres)">{editData.hechos}</Field>
              )}
            </div>
          </div>
        </div>
      </form>
    </AUIModal>
  );
};
ModalPersonasImplicadas.propTypes = {
  editData: shape({}),
  show: bool,
  onAccept: func,
  onClose: func,
  isVerData: bool,
};
ModalPersonasImplicadas.defaultProps = {
  editData: null,
  isVerData: false,
  show: false,
  onAccept: null,
  onClose: null,
};

export default ModalPersonasImplicadas;
